// extracted by mini-css-extract-plugin
export default {"teamControllerBox":"TeamsController_teamControllerBox__RDvNX","admin":"TeamsController_admin__7NQeg","noAdmin":"TeamsController_noAdmin__d5we8"};